(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53027);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;
var useAppDispatch = function() {
    return (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
};


/***/ }),

/***/ 53027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Container/Container.js + 1 modules
var Container = __webpack_require__(72445);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Text/Text.js + 1 modules
var Text = __webpack_require__(95117);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Anchor/Anchor.js + 1 modules
var Anchor = __webpack_require__(54685);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ActionIcon/ActionIcon.js + 1 modules
var ActionIcon = __webpack_require__(49834);
// EXTERNAL MODULE: ./node_modules/@tabler/icons/icons-react/dist/index.esm.js
var index_esm = __webpack_require__(63991);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/GryzleLogo.tsx
var GryzleLogo = __webpack_require__(59519);
;// CONCATENATED MODULE: ./src/components/Footer.tsx







var useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        footer: {
            marginTop: 120,
            borderTop: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[2])
        },
        inner: (0,_define_property/* default */.Z)({
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: theme.spacing.xl,
            paddingBottom: theme.spacing.xl
        }, theme.fn.smallerThan("xs"), {
            flexDirection: "column"
        }),
        links: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            marginTop: theme.spacing.md
        })
    };
});
var Footer = function() {
    var classes = useStyles().classes;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: classes.footer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: classes.inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GryzleLogo/* default */.Z, {
                    height: 28
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                    children: [
                        "Made with ❤️ by",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            passHref: true,
                            href: "https://itishermann.me",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor/* Anchor */.e, {
                                component: "a",
                                target: "_blank",
                                children: "itishermann"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 0,
                    className: classes.links,
                    position: "right",
                    noWrap: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                            size: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconBrandTwitter, {
                                size: 18,
                                stroke: 1.5
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                            size: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconBrandYoutube, {
                                size: 18,
                                stroke: 1.5
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionIcon/* ActionIcon */.A, {
                            size: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconBrandInstagram, {
                                size: 18,
                                stroke: 1.5
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var components_Footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(67841);
// EXTERNAL MODULE: ./node_modules/@growthbook/growthbook-react/dist/esm/index.js + 4 modules
var esm = __webpack_require__(97221);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-intersection/use-intersection.js
var use_intersection = __webpack_require__(46613);
;// CONCATENATED MODULE: ./src/context/Home.context.ts

var activeSection = "";
var setActiveSection = function(id) {
    activeSection = id;
};
var HomeContext = (0,react.createContext)({
    activeSection: activeSection,
    setActiveSection: setActiveSection
});
/* harmony default export */ var Home_context = (HomeContext);

// EXTERNAL MODULE: ./node_modules/next-plausible/dist/index.esm.js
var dist_index_esm = __webpack_require__(5017);
;// CONCATENATED MODULE: ./src/components/HomePage/Hero.tsx










var BREAKPOINT = "@media (max-width: 755px)";
var Hero_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        wrapper: {
            position: "relative",
            boxSizing: "border-box",
            alignItems: "center"
        },
        inner: (0,_define_property/* default */.Z)({
            position: "relative",
            paddingTop: 200,
            paddingBottom: 120
        }, BREAKPOINT, {
            paddingBottom: 80,
            paddingTop: 80
        }),
        title: (0,_define_property/* default */.Z)({
            fontFamily: "Greycliff CF, ".concat(theme.fontFamily),
            fontSize: 62,
            fontWeight: 900,
            lineHeight: 1.1,
            margin: 0,
            padding: 0,
            color: theme.colorScheme === "dark" ? theme.white : theme.black
        }, BREAKPOINT, {
            fontSize: 42,
            lineHeight: 1.2
        }),
        description: (0,_define_property/* default */.Z)({
            marginTop: theme.spacing.xl,
            fontSize: 24
        }, BREAKPOINT, {
            fontSize: 18
        }),
        controls: (0,_define_property/* default */.Z)({
            marginTop: theme.spacing.xl * 2
        }, BREAKPOINT, {
            marginTop: theme.spacing.xl
        }),
        control: (0,_define_property/* default */.Z)({
            height: 54,
            paddingLeft: 38,
            paddingRight: 38
        }, BREAKPOINT, {
            height: 54,
            paddingLeft: 18,
            paddingRight: 18,
            flex: 1
        })
    };
});
var Hero = function() {
    var plausible = (0,dist_index_esm/* usePlausible */.wW)();
    var classes = Hero_useStyles().classes;
    var ref = (0,router.useRouter)(), _query = ref.query, _provider = _query.provider, provider = _provider === void 0 ? "1" : _provider;
    var ref1 = (0,react.useContext)(Home_context), activeSection = ref1.activeSection, setActiveSection = ref1.setActiveSection;
    var ref2 = (0,use_intersection/* useIntersection */.s)({
        threshold: 1
    }), ref3 = ref2.ref, entry = ref2.entry;
    var isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    (0,react.useEffect)(function() {
        if (isVisible && activeSection !== "hero") {
            setActiveSection("hero");
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classes.wrapper,
        id: "hero",
        ref: ref3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            size: 700,
            className: classes.inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    className: classes.title,
                    children: [
                        "Your forex trading",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            component: "span",
                            variant: "gradient",
                            gradient: {
                                from: "blue",
                                to: "cyan"
                            },
                            inherit: true,
                            children: "Simplified"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: classes.description,
                    color: "dimmed",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* FeatureString */.lO, {
                        feature: "".concat(provider === "1" ? "provider" : "customer", "-subheading-conversion-rate"),
                        default: provider === "1" ? "Built with the purpose of easing the process from trading on forex to marketing your services, Gryzle is a cost effective solution for maintaining your business." : "Trading made easy. Signal Copying, billing and automating the less pleasant parts of forex trading."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                    className: classes.controls,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/auth/register",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            component: "a",
                            size: "xl",
                            className: classes.control,
                            variant: "gradient",
                            gradient: {
                                from: "blue",
                                to: "cyan"
                            },
                            onClick: function() {
                                return plausible("Click on CTA", {
                                    props: {
                                        type: "button",
                                        content: "Become an early tester",
                                        location: "Home page - hero"
                                    }
                                });
                            },
                            children: "Become an early tester"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_Hero = (Hero);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/ThemeIcon/ThemeIcon.js + 1 modules
var ThemeIcon = __webpack_require__(5044);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Title/Title.js + 1 modules
var Title = __webpack_require__(19236);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Tabs/Tabs.js + 10 modules
var Tabs = __webpack_require__(80579);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/SimpleGrid/SimpleGrid.js + 2 modules
var SimpleGrid = __webpack_require__(89814);
;// CONCATENATED MODULE: ./src/components/HomePage/UseCases.tsx









var UseCases_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        wrapper: {
            paddingTop: 80,
            paddingBottom: 50,
            transitionDuration: "0.3s"
        },
        item: {
            display: "flex"
        },
        itemIcon: {
            padding: theme.spacing.xs,
            marginRight: theme.spacing.md
        },
        itemTitle: {
            marginBottom: theme.spacing.xs / 2
        },
        supTitle: {
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: 800,
            fontSize: theme.fontSizes.sm,
            color: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).color,
            letterSpacing: 0.5
        },
        title: {
            lineHeight: 1,
            textAlign: "center",
            marginTop: theme.spacing.xl
        },
        description: {
            textAlign: "center",
            marginTop: theme.spacing.xs
        },
        highlight: {
            backgroundColor: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).background,
            padding: 5,
            paddingTop: 0,
            borderRadius: theme.radius.sm,
            display: "inline-block",
            color: theme.colorScheme === "dark" ? theme.white : "inherit"
        },
        tab: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.fn.focusStyles()), {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[4]),
            padding: "".concat(theme.spacing.xs, "px ").concat(theme.spacing.md, "px"),
            cursor: "pointer",
            fontSize: theme.fontSizes.sm,
            display: "flex",
            alignItems: "center",
            "&:disabled": {
                opacity: 0.5,
                cursor: "not-allowed"
            },
            "&:not(:first-of-type)": {
                borderLeft: 0
            },
            "&:first-of-type": {
                borderTopLeftRadius: theme.radius.md,
                borderBottomLeftRadius: theme.radius.md
            },
            "&:last-of-type": {
                borderTopRightRadius: theme.radius.md,
                borderBottomRightRadius: theme.radius.md
            },
            "&[data-active]": {
                backgroundColor: theme.colors.blue[7],
                borderColor: theme.colors.blue[7],
                color: theme.white
            }
        }),
        tabIcon: {
            marginRight: theme.spacing.xs,
            display: "flex",
            alignItems: "center"
        },
        tabsList: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
});
var customers = [
    {
        icon: "IconDeviceAnalytics",
        title: "Analytics",
        description: "Choose the signal provider that suits your trading style with the help of our extended analytics."
    },
    {
        icon: "IconTarget",
        title: "Catch all signals",
        description: "You will never miss a signal (i can't guarantee you'll make a profit but i'll help you if anything goes wrong). "
    },
    {
        icon: "IconCloudComputing",
        title: "99.8% SLA",
        description: "We make trading easy and allow you to grow your account while you sleep"
    },
    {
        icon: "IconBooks",
        title: "Education materials",
        description: "We have a complete set of educational materials that will help you understand the basics of trading."
    }, 
];
var providers = [
    {
        icon: "IconReceipt",
        title: "Billing automation",
        description: "Integration with all Twitter, Facebook and Telegram allows you to kick bad customers off your channels automatically."
    },
    {
        icon: "IconWallet",
        title: "Low cost",
        description: "Save time and energy by paying 1% of your profits per month instead of managing it all by yourself."
    },
    {
        icon: "IconCalendarOff",
        title: "99.8% SLA",
        description: "Enjoy the convenience of managing your clients and trades while you're away."
    },
    {
        icon: "IconAd2",
        title: "Marketing",
        description: "We take care of setting up your social media channels, your billing, your advertisements and much more."
    }, 
];
var UseCases = function() {
    var classes = UseCases_useStyles().classes;
    var ref = (0,router.useRouter)(), _query = ref.query, _provider = _query.provider, provider = _provider === void 0 ? "1" : _provider;
    var ref1 = (0,react.useContext)(Home_context), activeSection = ref1.activeSection, setActiveSection = ref1.setActiveSection;
    var ref2 = (0,use_intersection/* useIntersection */.s)({
        threshold: 1
    }), entry = ref2.entry, ref3 = ref2.ref;
    var isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    (0,react.useEffect)(function() {
        if (isVisible && activeSection !== "use-cases") {
            setActiveSection("use-cases");
        }
    }, [
        isVisible
    ]);
    var providerFeatues = providers.map(function(item) {
        var Icon = index_esm[item.icon];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.item,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    variant: "gradient",
                    gradient: {
                        from: "blue",
                        to: "cyan",
                        deg: 70
                    },
                    className: classes.itemIcon,
                    size: 60,
                    radius: "md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            weight: 700,
                            size: "lg",
                            className: classes.itemTitle,
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "dimmed",
                            children: item.description
                        })
                    ]
                })
            ]
        }, item.icon);
    });
    var customerFeatues = customers.map(function(item) {
        var Icon = index_esm[item.icon];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.item,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                    variant: "gradient",
                    gradient: {
                        from: "blue",
                        to: "cyan",
                        deg: -70
                    },
                    className: classes.itemIcon,
                    size: 60,
                    radius: "md",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            weight: 700,
                            size: "lg",
                            className: classes.itemTitle,
                            children: item.title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                            color: "dimmed",
                            children: item.description
                        })
                    ]
                })
            ]
        }, item.icon);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "use-cases",
        ref: ref3,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            size: 900,
            className: classes.wrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    className: classes.supTitle,
                    children: "Use cases"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                    className: classes.title,
                    order: 2,
                    children: [
                        "Gryzle is",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: classes.highlight,
                            children: "for everyone"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                    size: 660,
                    p: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        color: "dimmed",
                        className: classes.description,
                        children: "Wether your are a trader or a signal provider, Gryzle can help you succeed in trading."
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                    unstyled: true,
                    classNames: {
                        tab: classes.tab,
                        tabIcon: classes.tabIcon,
                        tabsList: classes.tabsList
                    },
                    defaultValue: provider === "1" ? "provider" : "customer",
                    mt: "lg",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs.List */.m.List, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "provider",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconSocial, {
                                        size: 14
                                    }),
                                    children: "For signal providers"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Tab */.m.Tab, {
                                    value: "customer",
                                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconUser, {
                                        size: 14
                                    }),
                                    children: "For solo traders"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                            value: "customer",
                            pt: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                                cols: 2,
                                spacing: 50,
                                breakpoints: [
                                    {
                                        maxWidth: 550,
                                        cols: 1,
                                        spacing: 40
                                    }
                                ],
                                style: {
                                    marginTop: 30
                                },
                                children: customerFeatues
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tabs.Panel */.m.Panel, {
                            value: "provider",
                            pt: "xs",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                                cols: 2,
                                spacing: 50,
                                breakpoints: [
                                    {
                                        maxWidth: 550,
                                        cols: 1,
                                        spacing: 40
                                    }
                                ],
                                style: {
                                    marginTop: 30
                                },
                                children: providerFeatues
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var HomePage_UseCases = (UseCases);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Center/Center.js
var Center = __webpack_require__(9094);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(82623);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(97564);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/MediaQuery/MediaQuery.js + 1 modules
var MediaQuery = __webpack_require__(18540);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Avatar/Avatar.js + 5 modules
var Avatar = __webpack_require__(99985);
;// CONCATENATED MODULE: ./src/components/UserTestimonial.tsx




var backgrounds = [
    "url(\"data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='102.633' cy='61.0737' rx='102.633' ry='61.0737' fill='%23ED64A6' /%3E%3Cellipse cx='399.573' cy='123.926' rx='102.633' ry='61.0737' fill='%23F56565' /%3E%3Cellipse cx='366.192' cy='73.2292' rx='193.808' ry='73.2292' fill='%2338B2AC' /%3E%3Cellipse cx='222.705' cy='110.585' rx='193.808' ry='73.2292' fill='%23ED8936' /%3E%3C/svg%3E\")",
    "url(\"data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='457.367' cy='123.926' rx='102.633' ry='61.0737' transform='rotate(-180 457.367 123.926)' fill='%23ED8936'/%3E%3Cellipse cx='160.427' cy='61.0737' rx='102.633' ry='61.0737' transform='rotate(-180 160.427 61.0737)' fill='%2348BB78'/%3E%3Cellipse cx='193.808' cy='111.771' rx='193.808' ry='73.2292' transform='rotate(-180 193.808 111.771)' fill='%230BC5EA'/%3E%3Cellipse cx='337.295' cy='74.415' rx='193.808' ry='73.2292' transform='rotate(-180 337.295 74.415)' fill='%23ED64A6'/%3E%3C/svg%3E\")",
    "url(\"data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='102.633' cy='61.0737' rx='102.633' ry='61.0737' fill='%23ED8936'/%3E%3Cellipse cx='399.573' cy='123.926' rx='102.633' ry='61.0737' fill='%2348BB78'/%3E%3Cellipse cx='366.192' cy='73.2292' rx='193.808' ry='73.2292' fill='%230BC5EA'/%3E%3Cellipse cx='222.705' cy='110.585' rx='193.808' ry='73.2292' fill='%23ED64A6'/%3E%3C/svg%3E\")",
    "url(\"data:image/svg+xml, %3Csvg xmlns='http://www.w3.org/2000/svg' width='560' height='185' viewBox='0 0 560 185' fill='none'%3E%3Cellipse cx='457.367' cy='123.926' rx='102.633' ry='61.0737' transform='rotate(-180 457.367 123.926)' fill='%23ECC94B'/%3E%3Cellipse cx='160.427' cy='61.0737' rx='102.633' ry='61.0737' transform='rotate(-180 160.427 61.0737)' fill='%239F7AEA'/%3E%3Cellipse cx='193.808' cy='111.771' rx='193.808' ry='73.2292' transform='rotate(-180 193.808 111.771)' fill='%234299E1'/%3E%3Cellipse cx='337.295' cy='74.415' rx='193.808' ry='73.2292' transform='rotate(-180 337.295 74.415)' fill='%2348BB78'/%3E%3C/svg%3E\")", 
];
var UserTestimonial_useStyles = (0,create_styles/* createStyles */.k)(function(theme, index) {
    return {
        wrapper: {
            padding: theme.spacing.lg,
            position: "relative",
            display: "flex",
            "&:before": {
                position: "absolute",
                backgroundImage: "".concat(backgrounds[index % backgrounds.length]),
                content: '""',
                height: "100%",
                maxWidth: "640px",
                width: "100%",
                filter: "blur(30px)",
                transform: "scale(0.9)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                top: 0,
                left: 0
            }
        },
        icon: {
            position: "absolute",
            height: "29px",
            width: "29px",
            left: "35px",
            top: "10px",
            backgroundSize: "cover",
            color: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).color
        },
        comment: {
            padding: "".concat(theme.spacing.lg, "px ").concat(theme.spacing.xl, "px"),
            position: "relative",
            flexDirection: "row",
            display: "flex",
            width: "100%"
        }
    };
});
var UserTestimonial = function(param) {
    var name = param.name, text = param.text, position = param.position, avatar = param.avatar, _icon = param.icon, icon = _icon === void 0 ? "IconQuote" : _icon, _index = param.index, index = _index === void 0 ? 0 : _index;
    var classes = UserTestimonial_useStyles(index).classes;
    var Icon = index_esm[icon];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* Paper */.X, {
                radius: "md",
                shadow: "md",
                className: classes.comment,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* Stack */.K, {
                        justify: "space-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                children: text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* MediaQuery */.z, {
                                        largerThan: "md",
                                        styles: {
                                            display: "none"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                            size: "md",
                                            src: avatar,
                                            alt: name,
                                            radius: "xl",
                                            style: {
                                                alignSelf: "center",
                                                justifySelf: "right"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                        component: "p",
                                        weight: "bold",
                                        size: "sm",
                                        children: [
                                            name,
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                                component: "span",
                                                weight: "normal",
                                                color: "dimmed",
                                                children: [
                                                    "-",
                                                    " ",
                                                    position
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaQuery/* MediaQuery */.z, {
                        smallerThan: "md",
                        styles: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                            size: "lg",
                            src: avatar,
                            alt: name,
                            radius: "xl",
                            style: {
                                alignSelf: "center"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                className: classes.icon
            })
        ]
    });
};
/* harmony default export */ var components_UserTestimonial = (UserTestimonial);

;// CONCATENATED MODULE: ./src/components/HomePage/Testimonials.tsx








var Testimonials_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        wrapper: {
            paddingTop: 80,
            paddingBottom: 50,
            transitionDuration: "0.3s"
        },
        item: {
            display: "flex"
        },
        itemIcon: {
            padding: theme.spacing.xs,
            marginRight: theme.spacing.md
        },
        itemTitle: {
            marginBottom: theme.spacing.xs / 2
        },
        supTitle: {
            textAlign: "center",
            textTransform: "uppercase",
            fontWeight: 800,
            fontSize: theme.fontSizes.sm,
            color: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).color,
            letterSpacing: 0.5
        },
        title: {
            lineHeight: 1,
            textAlign: "center",
            marginTop: theme.spacing.xl
        },
        description: {
            textAlign: "center",
            marginTop: theme.spacing.xs
        },
        highlight: {
            backgroundColor: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).background,
            padding: 5,
            paddingTop: 0,
            borderRadius: theme.radius.sm,
            display: "inline-block",
            color: theme.colorScheme === "dark" ? theme.white : "inherit"
        },
        tab: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.fn.focusStyles()), {
            backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[9],
            border: "1px solid ".concat(theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[4]),
            padding: "".concat(theme.spacing.xs, "px ").concat(theme.spacing.md, "px"),
            cursor: "pointer",
            fontSize: theme.fontSizes.sm,
            display: "flex",
            alignItems: "center",
            "&:disabled": {
                opacity: 0.5,
                cursor: "not-allowed"
            },
            "&:not(:first-of-type)": {
                borderLeft: 0
            },
            "&:first-of-type": {
                borderTopLeftRadius: theme.radius.md,
                borderBottomLeftRadius: theme.radius.md
            },
            "&:last-of-type": {
                borderTopRightRadius: theme.radius.md,
                borderBottomRightRadius: theme.radius.md
            },
            "&[data-active]": {
                backgroundColor: theme.colors.blue[7],
                borderColor: theme.colors.blue[7],
                color: theme.white
            }
        }),
        tabIcon: {
            marginRight: theme.spacing.xs,
            display: "flex",
            alignItems: "center"
        },
        tabsList: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
        }
    };
});
var testimonials = [
    {
        name: "Alicia M.",
        text: "With Gryzle you can keep your customers happy and get more of them, all at the same time. Try it out today.",
        position: "Signal provider",
        avatar: "https://minio.snowtrust.fr/gryzle-public-production/avatar/image-3.jpeg",
        icon: "IconMoodCrazyHappy"
    },
    {
        text: "Sounds too good to be true? Well, it's not. Gryzle is the best way to get more customers and keep them happy.",
        name: "Justin P.",
        position: "Signal provider",
        avatar: "https://minio.snowtrust.fr/gryzle-public-production/avatar/image-2.jpeg",
        icon: "IconFlame"
    },
    {
        text: "The platform helps you get more customers by automating the onboarding process, as well as billing and payments.",
        name: "Alex S.",
        position: "Signal provider",
        icon: "IconTrendingUp",
        avatar: "https://minio.snowtrust.fr/gryzle-public-production/avatar/image-4.jpeg"
    },
    {
        text: "If you are looking for a Copy Trading platform that solves your issues, stop looking!",
        name: "Wilson A.",
        position: "Solo trader",
        avatar: "https://minio.snowtrust.fr/gryzle-public-production/avatar/image-5.jpeg"
    }, 
];
function Testimonials() {
    var classes = Testimonials_useStyles().classes;
    var ref = (0,react.useContext)(Home_context), activeSection = ref.activeSection, setActiveSection = ref.setActiveSection;
    var ref1 = (0,use_intersection/* useIntersection */.s)({
        threshold: 1
    }), ref2 = ref1.ref, entry = ref1.entry;
    var isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    (0,react.useEffect)(function() {
        if (isVisible && activeSection !== "testimonials") {
            setActiveSection("testimonials");
        }
    }, [
        isVisible
    ]);
    var items = testimonials.map(function(param, index) {
        var name = param.name, text = param.text, position = param.position, avatar = param.avatar, icon = param.icon;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_UserTestimonial, {
            index: index,
            avatar: avatar,
            name: name,
            text: text,
            icon: icon,
            position: position
        }, name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "testimonials",
        ref: ref2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Center/* Center */.M, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                size: 1200,
                className: classes.wrapper,
                p: 0,
                m: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                        component: "p",
                        className: classes.supTitle,
                        children: "People love us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                        className: classes.title,
                        order: 2,
                        children: [
                            "You are in good",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                component: "span",
                                variant: "gradient",
                                gradient: {
                                    from: "indigo",
                                    to: "cyan",
                                    deg: 45
                                },
                                children: "company"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
                        size: 700,
                        p: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            component: "p",
                            color: "dimmed",
                            className: classes.description,
                            children: [
                                "See why our early testers use Gryzle to manage their clients",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "and take their trading to the next level"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleGrid/* SimpleGrid */.M, {
                        cols: 2,
                        m: "auto",
                        pt: "lg",
                        spacing: 0,
                        breakpoints: [
                            {
                                maxWidth: 550,
                                cols: 1,
                                spacing: 40
                            }
                        ],
                        children: items
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var HomePage_Testimonials = (Testimonials);

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/List/List.js + 4 modules
var List = __webpack_require__(8949);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Image/Image.js + 2 modules
var Image = __webpack_require__(39954);
;// CONCATENATED MODULE: ./src/components/HomePage/ExplanationHero.tsx










var ExplanationHero_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        inner: {
            display: "flex",
            justifyContent: "space-between",
            paddingTop: theme.spacing.xl * 4,
            paddingBottom: theme.spacing.xl * 4
        },
        content: (0,_define_property/* default */.Z)({
            maxWidth: 480,
            marginRight: theme.spacing.xl * 3
        }, theme.fn.smallerThan("md"), {
            maxWidth: "100%",
            marginRight: 0
        }),
        title: {
            lineHeight: 1,
            marginTop: theme.spacing.xl
        },
        control: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("xs"), {
            flex: 1
        }),
        supTitle: {
            textTransform: "uppercase",
            fontWeight: 800,
            fontSize: theme.fontSizes.sm,
            color: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).color,
            letterSpacing: 0.5
        },
        image: (0,_define_property/* default */.Z)({
            flex: 1,
            alignSelf: "center",
            position: "relative",
            "&:before": {
                position: "absolute",
                backgroundSize: "1.9em 1.9em",
                backgroundImage: "\n      linear-gradient(".concat(theme.colors.gray[9], " .1em, transparent .1em),\n      linear-gradient(90deg, ").concat(theme.colors.gray[9], " .1em, transparent .1em)\n      "),
                mask: "radial-gradient(circle, white 1%, transparent 100%)",
                height: "100%",
                maxWidth: "640px",
                width: "100%",
                content: '""',
                transform: "scale(1.2)",
                top: 0,
                left: 0
            }
        }, theme.fn.smallerThan("md"), {
            display: "none"
        }),
        highlight: {
            position: "relative",
            backgroundColor: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).background,
            borderRadius: theme.radius.sm,
            padding: "4px 12px"
        }
    };
});
function ExplanationHero() {
    var plausible = (0,dist_index_esm/* usePlausible */.wW)();
    var classes = ExplanationHero_useStyles().classes;
    var ref = (0,react.useContext)(Home_context), activeSection = ref.activeSection, setActiveSection = ref.setActiveSection;
    var ref1 = (0,use_intersection/* useIntersection */.s)({
        threshold: 1
    }), ref2 = ref1.ref, entry = ref1.entry;
    var isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    (0,react.useEffect)(function() {
        if (isVisible && activeSection !== "how-it-works") {
            setActiveSection("how-it-works");
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "how-it-works",
        ref: ref2,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                component: "p",
                                className: classes.supTitle,
                                children: "Functionnalities"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* Title */.D, {
                                className: classes.title,
                                order: 2,
                                children: "How does it work ?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                color: "dimmed",
                                mt: "md",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* FeatureString */.lO, {
                                    feature: "how-it-works-description",
                                    default: "Gryzle is designed with the end user in mind. With our easy to use interface and features, you can focus on your trading instead of lost time and effort on administrational tasks. Using Gryzle to handle customer onboarding and multiple payment gateways, you can focus on providing quality signals to your customers, who will benefit from your expertise."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List */.a, {
                                mt: 30,
                                spacing: "sm",
                                size: "sm",
                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                    size: 20,
                                    radius: "xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconCheck, {
                                        size: 12,
                                        stroke: 1.5
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List.Item */.a.Item, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                            size: 20,
                                            radius: "xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconRefresh, {
                                                size: 12,
                                                stroke: 1.5
                                            })
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Bidirectionnal sync"
                                            }),
                                            " ",
                                            "– When a signal is publisehd by your provider on a social network, it is automatically sent to your metatrader terminal and if you are a provider, your signals are automatically sent to your customers."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List.Item */.a.Item, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                            size: 20,
                                            radius: "xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconBolt, {
                                                size: 12,
                                                stroke: 1.5
                                            })
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Blazingly fast"
                                            }),
                                            " ",
                                            "– Near instantaneous speed, because speed execution is the key."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* List.Item */.a.Item, {
                                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeIcon/* ThemeIcon */.k, {
                                            size: 20,
                                            radius: "xl",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconCash, {
                                                size: 12,
                                                stroke: 1.5
                                            })
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: "Low cost"
                                            }),
                                            " ",
                                            "– Gryzle is designed to be reduce the pain of trading and to be the best solution for your trading needs. So goes the price."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Group/* Group */.Z, {
                                mt: 30,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/auth/register",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        component: "a",
                                        size: "xl",
                                        className: classes.control,
                                        variant: "gradient",
                                        gradient: {
                                            from: "blue",
                                            to: "cyan"
                                        },
                                        onClick: function() {
                                            return plausible("Click on CTA", {
                                                props: {
                                                    type: "button",
                                                    content: "Try it out",
                                                    location: "Home page - how-it-works"
                                                }
                                            });
                                        },
                                        children: "Try it out"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                        src: "/static/assets/images/gryzle_diagram.png",
                        className: classes.image
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var HomePage_ExplanationHero = (ExplanationHero);

;// CONCATENATED MODULE: ./src/components/HomePage/FinalCTA.tsx







var FinalCTA_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        wrapper: {
            paddingTop: 80,
            paddingBottom: 50
        },
        supTitle: {
            textTransform: "uppercase",
            fontWeight: 800,
            fontSize: theme.fontSizes.sm,
            color: theme.fn.variant({
                variant: "light",
                color: theme.primaryColor
            }).color,
            letterSpacing: 0.5
        },
        description: {
            marginTop: theme.spacing.xs
        }
    };
});
var FinalCTA = function() {
    var plausible = (0,dist_index_esm/* usePlausible */.wW)();
    var classes = FinalCTA_useStyles().classes;
    var ref = (0,react.useContext)(Home_context), activeSection = ref.activeSection, setActiveSection = ref.setActiveSection;
    var ref1 = (0,use_intersection/* useIntersection */.s)({
        threshold: 1
    }), ref2 = ref1.ref, entry = ref1.entry;
    var isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    (0,react.useEffect)(function() {
        if (isVisible && activeSection !== "call-to-action") {
            setActiveSection("call-to-action");
        }
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "call-to-action",
        ref: ref2,
        className: classes.wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            size: 1200,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                        size: 700,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                component: "p",
                                className: classes.supTitle,
                                children: "Get started now"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Title/* Title */.D, {
                                order: 2,
                                children: [
                                    "Coping trades manually is",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                                        component: "span",
                                        variant: "gradient",
                                        gradient: {
                                            from: "indigo",
                                            to: "cyan",
                                            deg: 45
                                        },
                                        children: "a big pain"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                                component: "p",
                                color: "dimmed",
                                className: classes.description,
                                children: [
                                    "Automating your trading with Gryzle and copying trades executed by other traders on our platform or those of professional signal providers will certainly make your life as a trade much easier and save you a lot of time.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Start really making the most of your time using our automated trading features, allowing you to spend less time doing mundane tasks and more time watching the markets."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/auth/register",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            component: "a",
                            size: "xl",
                            variant: "gradient",
                            gradient: {
                                from: "blue",
                                to: "cyan"
                            },
                            onClick: function() {
                                return plausible("Click on CTA", {
                                    props: {
                                        type: "button",
                                        content: "Become an early tester",
                                        location: "Home page - call-to-action"
                                    }
                                });
                            },
                            children: "Become an early tester"
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var HomePage_FinalCTA = (FinalCTA);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/AppShell/Header/Header.js + 2 modules
var Header = __webpack_require__(80353);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Code/Code.js + 1 modules
var Code = __webpack_require__(67084);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Burger/Burger.js + 1 modules
var Burger = __webpack_require__(81310);
// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Transition/Transition.js
var Transition = __webpack_require__(97688);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-disclosure/use-disclosure.js
var use_disclosure = __webpack_require__(91759);
// EXTERNAL MODULE: ./src/hooks/redux.hook.ts
var redux_hook = __webpack_require__(69569);
// EXTERNAL MODULE: ./package.json
var package_0 = __webpack_require__(4147);
;// CONCATENATED MODULE: ./src/components/Header.tsx












var HEADER_HEIGHT = 60;
var Header_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        root: {
            position: "fixed",
            zIndex: 1,
            top: 0
        },
        dropdown: (0,_define_property/* default */.Z)({
            position: "absolute",
            top: HEADER_HEIGHT,
            left: 0,
            right: 0,
            zIndex: 0,
            borderTopRightRadius: 0,
            borderTopLeftRadius: 0,
            borderTopWidth: 0,
            overflow: "hidden"
        }, theme.fn.largerThan("sm"), {
            display: "none"
        }),
        header: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%"
        },
        links: (0,_define_property/* default */.Z)({}, theme.fn.smallerThan("sm"), {
            display: "none"
        }),
        burger: (0,_define_property/* default */.Z)({}, theme.fn.largerThan("sm"), {
            display: "none"
        }),
        link: (0,_define_property/* default */.Z)({
            display: "block",
            lineHeight: 1,
            padding: "8px 12px",
            borderRadius: theme.radius.sm,
            textDecoration: "none",
            color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
            fontSize: theme.fontSizes.sm,
            fontWeight: 500,
            "&:hover": {
                backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.colors.gray[0]
            }
        }, theme.fn.smallerThan("sm"), {
            borderRadius: 0,
            padding: theme.spacing.md
        }),
        linkActive: {
            "&, &:hover": {
                backgroundColor: theme.fn.variant({
                    variant: "light",
                    color: theme.primaryColor
                }).background,
                color: theme.fn.variant({
                    variant: "light",
                    color: theme.primaryColor
                }).color
            }
        }
    };
});
var defaultLinks = [];
var HeaderResponsive = function(param) {
    var _links = param.links, links = _links === void 0 ? defaultLinks : _links;
    var ref = (0,_sliced_to_array/* default */.Z)((0,use_disclosure/* useDisclosure */.q)(false), 2), opened = ref[0], ref1 = ref[1], toggle = ref1.toggle, close = ref1.close;
    var ref2 = Header_useStyles(), classes = ref2.classes, cx = ref2.cx;
    var activeSection = (0,react.useContext)(Home_context).activeSection;
    var ref3 = (0,redux_hook/* useAppSelector */.C)(function(state) {
        return state.user;
    }), kuid = ref3._id;
    var items = links.map(function(link) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
            href: link.link,
            className: cx(classes.link, (0,_define_property/* default */.Z)({}, classes.linkActive, activeSection === link.id)),
            onClick: function(event) {
                var ref;
                var offsetTop = ((ref = document.getElementById(link.id)) === null || ref === void 0 ? void 0 : ref.offsetTop) || 0;
                window.scrollTo({
                    top: offsetTop - HEADER_HEIGHT,
                    behavior: "smooth"
                });
                event.preventDefault();
                close();
            },
            children: link.label
        }, link.label);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* Header */.h, {
        height: HEADER_HEIGHT,
        className: classes.root,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
            className: classes.header,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        alignItems: "center",
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GryzleLogo/* default */.Z, {
                            height: 28
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Code/* Code */.E, {
                            sx: {
                                fontWeight: 700,
                                alignSelf: "center"
                            },
                            ml: "sm",
                            children: [
                                "Alpha",
                                " ",
                                package_0/* version */.i8
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Group/* Group */.Z, {
                    spacing: 5,
                    className: classes.links,
                    children: [
                        items,
                        kuid && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/app",
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                component: "a",
                                rightIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm.IconArrowRight, {
                                    size: 14
                                }),
                                children: "Go to dashboard"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Burger/* Burger */.O, {
                    opened: opened,
                    onClick: toggle,
                    className: classes.burger,
                    size: "sm"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Transition/* Transition */.u, {
                    transition: "pop-top-right",
                    duration: 200,
                    mounted: opened,
                    children: function(styles) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* Paper */.X, {
                            className: classes.dropdown,
                            withBorder: true,
                            style: styles,
                            children: items
                        });
                    }
                })
            ]
        })
    });
};
/* harmony default export */ var components_Header = (HeaderResponsive);

;// CONCATENATED MODULE: ./src/pages/index.tsx

/* eslint-disable react/jsx-no-constructed-context-values */ 









var pages_useStyles = (0,create_styles/* createStyles */.k)(function(theme) {
    return {
        main: {
            "& > section": {
                alignItems: "center",
                justifyContent: "center"
            }
        }
    };
});
var links = [
    {
        label: "Use Cases",
        id: "use-cases",
        link: "#use-cases"
    },
    {
        label: "How it works",
        id: "how-it-works",
        link: "#how-it-works"
    },
    {
        label: "Testimonials",
        id: "testimonials",
        link: "#testimonials"
    },
    {
        label: "Try Gryzle now",
        id: "call-to-action",
        link: "#call-to-action"
    }, 
];
var Index = function() {
    var classes = pages_useStyles().classes;
    var ref = (0,react.useState)("hero"), activeSection = ref[0], setActiveSection = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
        className: classes.main,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Home_context.Provider, {
            value: {
                activeSection: activeSection,
                setActiveSection: setActiveSection
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Header, {
                    links: links
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_Hero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_UseCases, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_ExplanationHero, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_Testimonials, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage_FinalCTA, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Footer, {})
            ]
        })
    });
};
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [584,178,270,238,811,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);